import { Flex } from "components/LEGACY/styled-components/Flex"
import PatternPageContainer from "components/utils/PatternPageContainer"
import ShopSignUpForm from "components/utils/ShopSignUpForm"

import getpackedLogo from "images/getpacked_Logo_schwarz.svg"
import Image from "next/image"

const ShopCreation = () => {
  return (
    <>
      <style jsx>{`
        .container {
          display: grid;
          justify-items: center;
          position: relative;
          grid-gap: 10px;
          margin: 20px;
        }
        .linkContainer {
          width: 100%;
          display: flex;
          justify-content: space-between;
          padding: 0 10px;
        }
      `}</style>
      <PatternPageContainer light>
        <Flex style={{ height: "100%" }} justifyCenter alignCenter>
          <div className="container">
            <Image src={getpackedLogo} alt={"getpacked logo"} layout="fixed" />

            <h1 style={{ color: "black" }}>Erstelle deinen Online-Shop</h1>
            <ShopSignUpForm />
            {/* <Link href="/forgot-password">Passwort vergessen?</Link> */}

            <hr />
            <div className="spacer" style={{ height: "50px" }} />
          </div>
        </Flex>
      </PatternPageContainer>
    </>
  )
}

export default ShopCreation
